<template>
	<fieldset
		:disabled="disabledByWizard"
		style="height: unset"
	>
		<label
			v-if="!isButton"
			:class="componentClassName"
			ref="inputRadio"
		>
			<span class="ir-icons">
				<i
					v-if="isInputSelected"
					class="far fa-dot-circle"
				/>
				<i
					v-else
					class="far fa-circle"
				/>

				<input
					v-if="!visualOnly"
					@change="onChangeHandler"
					@click="onInputHandler"
					:disabled="disabled"
					v-model="vm.isSelected"
					:value="valueMatch"
					type="radio"
					:style="{ opacity: '0', width: '0', height: '0' }"
				/>
			</span>
			<span
				v-if="label"
				class="ir-label"
			>
				{{ label === '_' ? '\u00A0' : label }}
			</span>
		</label>
		<label
			v-else
			:class="componentClassName"
			ref="inputRadio"
		>
			<input
				v-if="!visualOnly"
				@click="onInputHandler"
				@change="onChangeHandler"
				:disabled="disabled"
				v-model="vm.isSelected"
				:value="valueMatch"
				type="radio"
				:style="{ opacity: '0', width: '0', height: '0' }"
			/>
			<span
				v-if="label"
				class="ir-label"
			>
				{{ label }}
			</span>
		</label>
	</fieldset>
</template>

<script>
	import util from '@core/services/util';

	export default {
		name: 'InputRadio',
		inject: {
			wizardLocks: {
				// Provided by FIMenuWizardContent
				from: 'fiMenuFieldLocks',
				default: () => null,
			},
		},
		emits: ['update:modelValue', 'click', 'input', 'change'],
		props: ['modelValue', 'label', 'valueMatch', 'sfx', 'disabled', 'isButton', 'visualOnly'],
		data() {
			return {
				vm: {
					isSelected: null,
				},
				disabledByWizard: null,
			};
		},
		watch: {
			wizardLocks: {
				handler: function () {
					this.disabledByWizard = this.isDisabledByWizard();
				},
				deep: true,
			},
		},
		computed: {
			componentClassName() {
				let className = 'input-radio';

				if (!this.disabled && !this.disabledByWizard) className += ' clickable';
				else className += ' disabled';

				if (this.isButton) className += ' button';
				if (this.isInputSelected) className += ' selected';
				if (this.sfx === false) return className;
				else className += ' sfx';

				return className;
			},
			isInputSelected() {
				if (util.isNull(this.vm.isSelected)) return false;
				return this.vm.isSelected === this.valueMatch;
			},
		},
		created() {
			this.init();

			this.$watch(
				() => this.$props,
				function (newValue) {
					this.init();
				},
				{ deep: true },
			);
		},
		mounted() {
			this.disabledByWizard = this.isDisabledByWizard();
		},
		methods: {
			onInputHandler(e) {
				if (this.disabled) return;
				this.$emit('click', e);
			},
			init() {
				this.vm.isSelected = this.modelValue;
			},
			onChangeHandler() {
				this.$emit('input', this.vm.isSelected);
				this.$emit('change', this.vm.isSelected);
				this.$emit('update:modelValue', this.vm.isSelected);
			},
			isDisabledByWizard() {
				if (!this.wizardLocks || !this.$refs.inputRadio) return false;
				return this.wizardLocks.isDisabled(this.$refs.inputRadio);
			},
		},
		components: {},
	};
</script>

<style>
	label.input-radio {
		display: flex;
		gap: 5px;
	}

	label.input-radio.sfx {
		transition: var(--transition);
	}

	label.input-radio.sfx:hover {
		color: var(--main-color);
		transition: var(--transition);
	}

	label.input-radio.button {
		width: fit-content;
		color: inherit;
		width: fit-content;
		padding: 5px 15px;
		border-radius: 4px;
		border: 1px solid;
		border-color: inherit;
		box-sizing: border-box;
		transition: var(--transition);
	}

	label.input-radio.button.selected {
		font-weight: 500;
	}

	label.input-radio.button input {
		position: absolute;
	}

	/*fieldset:not(:disabled) .input-radio.sfx:hover {}*/

	fieldset:disabled label.input-radio.sfx,
	fieldset:disabled label.input-radio.sfx:hover,
	label.input-radio.sfx:has(input:disabled),
	label.input-radio.sfx:hover:has(input:disabled) {
		/* No hover effect for disabled fieldset parent */
		cursor: not-allowed !important;
		color: var(--fieldset-input-color-disabled);
		transition: var(--transition);
	}

	fieldset:disabled label.input-radio.button.sfx,
	fieldset:disabled label.input-radio.button.sfx:hover,
	label.input-radio.button.sfx:has(input:disabled),
	label.input-radio.button.sfx:hover:has(input:disabled) {
		background: var(--black-10percent);
		color: var(--disabled-color);
		border-color: var(--border-color) !important;
	}

	fieldset:disabled label.input-radio.button.selected.sfx,
	fieldset:disabled label.input-radio.button.selected.sfx:hover,
	label.input-radio.button.selected.sfx:has(input:disabled),
	label.input-radio.button.selected.sfx:hover:has(input:disabled) {
		border-color: var(--disabled-color) !important;
	}

	fieldset:not(:disabled) label.input-radio.button:not(.disabled):hover,
	label.input-radio.button.selected {
		color: var(--background-color);
		border-color: var(--main-color);
		background-color: var(--main-color);
	}
</style>
